import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { Ipv4 } from 'motion-master-client';

import { ParameterFormControlValidationErrorsComponent } from '@app/shared/parameter-form-control-validation-errors/parameter-form-control-validation-errors.component';

@Component({
  selector: 'app-form-control-ipv4',
  templateUrl: './form-control-ipv4.component.html',
  imports: [ParameterFormControlValidationErrorsComponent],
})
export class FormControlIpv4Component implements ControlValueAccessor {
  private ngControl = inject(NgControl, { optional: true, self: true });

  value: Ipv4 = '0.0.0.0'; // Initially set to "not used" value

  @Input()
  disabled: boolean = false;

  @Output()
  keyUp = new EventEmitter<KeyboardEvent>();

  get invalid() {
    return this.ngControl?.invalid;
  }

  get errors() {
    return this.ngControl?.errors;
  }

  constructor() {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  onChange: (value: Ipv4) => void;
  onTouched: () => void;

  writeValue(value: Ipv4): void {
    this.value = value;
  }

  registerOnChange(fn: (value: Ipv4) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  updateValue(event: Event): void {
    this.value = (event.target as HTMLInputElement).value as Ipv4;
    this.onChange(this.value);
    this.onTouched();
  }
}
